import { useContext } from 'react'
import { LeadsAccountSellersContext } from './constant'
import { ILeadsAccountSellersContext } from './types'

const useLeadsAccountSellers = () => {
  const context = useContext(LeadsAccountSellersContext)

  if (!context) {
    throw new Error(
      'Não foi possível recuperar o contexto solicitado. Certifique-se de que o componente está encapsulado pelo LeadsAccountSellersContext.Provider.'
    )
  }

  return context as ILeadsAccountSellersContext
}

export default useLeadsAccountSellers
